/*
 * 文件EN: badRecord.js,
 * 文件CN: 不良列表,
 * 创建时间: Friday, 15th May 2020 5:17:26 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import request from '@/plugins/http';
let headers = {
	// 'Content-Type': 'application/x-www-form-urlencoded'
	'Content-Type': 'application/json'
}
/**
 * @desc 列表获取
 * @method GET
 * @param { 参数说明 详细见swagger  } 
    */
export const getListData = params => {
	return request.get('/badRecord/queryList', params)
}

/**
 * @desc 根据商户号查询商户额度
 * @method GET
 * @param { merNo:""}
 */
export const getBalance = params => {
	return request.get('/badRecord/getBalance', params)
}

/**
 * @desc 查询商户支付终端信息
 * @method GET
 * @param { merNo:""}
 */
export const getMerchantStatus = params => {
	return request.get('/badRecord/getMerchantStatus', params)
}

/**
 * @desc 根据商户号，查询触发的逾期记录
 * @method GET
 * @param { merNo:""}
 */
export const overdueRecord = params => {
	return request.get('/badRecord/overdueRecord', params)
}

/**
 * @desc 获取该商户下所有卡-额度授信账户
 * @method GET
 * @param { merNo:""}
 */
export const queryCardList = params => {
	return request.get('/merchant/card/queryCardList', params)
}

/**
 * @desc 获取该商户聚合支付信息
 * @method GET
 * @param { merId:""}
 */
export const queryUnionPayment = params => {
	return request.get('/badRecord/queryUnionPayment', params)
}

/**
 * @desc 根据商户号，查询触发的风控记录
 * @method GET
 * @param { merId:""}
 */
export const riskRecord = params => {
	return request.get('/badRecord/riskRecord', params)
}

/**
 * @desc 根据商户id，查询审批信息
 * @method GET
 * @param { merId:""}
 */
export const getMerchantApply = params => {
	return request.get('/badRecord/getMerchantApply', params)
}